(function () {
    'use strict';

    angular
        .module('app')
        .controller('acquirecheckout', acquirecheckout);

    acquirecheckout.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', 'selectionCommandService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService'];

    function acquirecheckout($location, scope, $rootScope, gridDataService, $q, selectionCommandService, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'acquirecheckout';

        scope.acquireCheckOutDialogShown = false;
        scope.ACN_ASSUME_OWNERSHIP = 127
        scope.xyz = { bReadyForOK: false};
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        //
        // Enables.
        //
        scope.doEnables = function () {
            var selected = scope.gridApi.selection.getSelectedRows();
            scope.xyz.bReadyForOK = selected.length == 1;
        }

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function () {
            // Do Enables.
            scope.doEnables();
        };

        // On click of the Assign button.
        scope.onAcquireCheckOutButtonClicked = function (slx) {
            // scope
            scope.slx = slx;
            scope.xyz = { bReadyForOK: false, bCopyDataCard: false};

            scope.gridOptions.columnDefs = [{ name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' }];

            scope.filename = scope.slx.list[0].filename;

            // dialog config
            scope.heading = loginService.resourceStrings["ACQUIRE_CHECK_OUT"]; // "Assign";
            scope.msg1 = loginService.resourceStrings["ACQUIRE_CHECK_OUT_MSG1"]; // "Files to Assign:";
            scope.msg2 = loginService.resourceStrings["ACQUIRE_CHECK_OUT_MSG2"]; // "Files to Assign:";
            scope.copyDataCardLabel = loginService.resourceStrings["COPY_DATA_CARD_AS_WELL"];
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            selectionCommandService.AcquireCheckOutSources(scope.filename).then(function (response) {
                var slx = response.data;
                if (slx == null) {
                    $rootScope.msgBoxShow("No files available to acquire.", "Error");
                    return;
                }
                scope.gridOptions.data = [];
                var index = 0;
                angular.forEach(slx.list, function (item) {
                    scope.gridOptions.data.push({
                        index: index,
                        selectionItem: item,
                        isSelected: true,
                        name: item.filename, library: item.detailedInfo.libName,
                        assignToId: "", assignTo: "",
                    });
                    index++;
                });

                // Enables.
                scope.selectItem();
                // Do modal.
                scope.acquireCheckOutDialogShown = true;
                $timeout(function () {
                    refreshGrid();
                    scope.gridApi.selection.selectAllRows();
                    $timeout(function () {
                        refreshGrid();
                    }, 2000);
                }, 500);
            }, function (response) {
                selectionCommandService.ShowEx(response);
            });
        };

        scope.doColumns = function () {
            // dialog config columns
            var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
            scope.gridOptions.columnDefs[0].name = colName;
            scope.gridOptions.columnDefs[1].name = colLibrary;
        }

        scope.onDisableTest = function () {
            scope.xyz.processing = !scope.xyz.processing;
        }

        scope.onAcquireCheckOutDialogOK = function () {
            scope.xyz.processing = true;

            var selected = scope.gridApi.selection.getSelectedRows();
            if (selected.length != 1) {
                $rootScope.msgBoxShow("Internal Error. onAcquireCheckOutDialogOK: selected.length != 1");
                return;
            }
            var libId = selected[0].selectionItem.detailedInfo.libId;

            angular.forEach(scope.slx.list, function (item) {
                item.commandParams.eLibId = libId;
                item.commandParams.ebCopyDataCard = scope.xyz.bCopyDataCard;
            });

            // Execute.
            selectionCommandService.AcquireCheckOut(scope.slx).then(function (response) {
                // Handle errors.
                var atLeastOneError = false;
                var selectionCommandResults = response.data;
                var slx = selectionCommandResults.slx;
                angular.forEach(slx.list, function (item) {
                    if (atLeastOneError == false) {
                        if (item.ec != 0) {
                            atLeastOneError = true;
                            if (atLeastOneError) {
                                commandService.launchErrors({ slx: slx });
                            }
                        }
                    }
                });
                // Close dialog and refresh grid.
                $mdDialog.hide();
                scope.xyz.processing = false;
                gridDataService.updateGridRecords(slx.list);

                editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
            }, function (response) {
                selectionCommandService.ShowEx(response); scope.xyz.processing = false;
            });
        };

        scope.onAcquireCheckOutDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.acquireCheckOutDialogClosed = function () {

        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
            scope.onAcquireCheckOutButtonClicked(records);
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
